import React, { Fragment } from 'react';
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-toastify/dist/ReactToastify.css';
import { sanitizeImageUrl } from '../../utils/multiuseFunctions';

const UserSkinTransactions = ({ myData, myClass }) => {
  const getItemDetails = (row) => {
    if (row?.tradeType === 'Deposit') {
      return row?.offer?.itemsToReceive || [];
    } else if (row?.tradeType === 'Withdraw') {
      return row?.sentItems || [];
    }
    return [];
  };

  const hasProductImages =
    myData?.length > 0 &&
    myData?.some((row) =>
      getItemDetails(row).some((item) => item?.skin?.image)
    );

  const columnDefs = [
    {
      name: 'S.No',
      selector: (row, index) => index + 1,
      sortable: true,
      width: '80px',
      center: true,
    },
    ...(hasProductImages
      ? [
          {
            name: 'Item Name',
            selector: (row) =>
              getItemDetails(row)
                .map(
                  (item) =>
                    item?.skin?.name ||
                    item?.skin?.name ||
                    item?.skin?.marketHashName ||
                    'N/A'
                )
                .join(', '),
            sortable: true,
            wrap: true,
            minWidth: '250px',
            grow: 2,
          },
          {
            name: 'Item Image',
            cell: (row) => (
            <div className="item-image-cell">
              {getItemDetails(row).map(
                (item, index) =>
                  item?.skin?.image && (
                    <ProfileImage key={index} row={item.skin} />
                  )
              )}
            </div>
          ),
          width: '250px',
          },
          {
            name: 'Price',
            selector: (row) =>
              getItemDetails(row)
                .map((item) => `${item?.skin?.price?.toFixed(2) || '0.00'}`)
                .join(', '),
            sortable: true,
            wrap: true,
            minWidth: '250px',
            grow: 2,
          },
        ]
      : []),
    {
      name: 'Trade Type',
      selector: (row) => row?.tradeType,
      sortable: true,
      width: '120px',
    },
    {
      name: 'Status',
      selector: (row) => row?.status,
      sortable: true,
      width: '120px',
    },
    {
      name: 'Date',
      selector: (row) => new Date(row?.createdAt).toLocaleString(),
      sortable: true,
      width: '200px',
    },
  ];

  return (
    <div>
      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={myData}
          print={false}
          export={false}
        >
          <DataTable
            data={myData}
            columns={columnDefs}
            className={myClass}
            pagination
            striped={true}
            responsive
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};
const ProfileImage = ({ row }) => {
  return (
    <div className='profile-image'>
      <img
        src={
          row.image.startsWith('http')
            ? sanitizeImageUrl(row.image)
            : `https://steamcommunity.com/economy/image/${row.image}`
        }
        alt='logo'
      />
    </div>
  );
};

export default UserSkinTransactions;
